import { render } from "./CIS-Home-Card-Item.vue?vue&type=template&id=b7ff4252"
import script from "./CIS-Home-Card-Item.vue?vue&type=script&lang=js"
export * from "./CIS-Home-Card-Item.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__